<template>
  <div class="exercise-container">
    <!-- Error Message -->
    <b-alert v-if="errorMessage" show variant="danger" class="text-center p-4">
      <h4 class="alert-heading mb-3">Akses Terbatas</h4>
      <p>Anda tidak mempunyai akses pada halaman ini</p>
      <hr />
      <a href="/logout" class="btn btn-outline-danger">
        <i class="uil uil-sign-out-alt me-2"></i>
        {{ $t("navbar.dropdown.marcus.list.logout") }}
      </a>
    </b-alert>

    <!-- Exercise Grid -->
    <div class="exercise-grid">
      <b-row>
        <b-col
          v-for="exercise in setSubLatihan"
          :key="exercise.id"
          lg="4"
          md="6"
          sm="12"
          class="mb-4"
        >
          <div class="exercise-card">
            <!-- Card Header with Icon -->
            <div class="card-header">
              <div class="exercise-icon" :class="exercise.type">
                <i :class="getExerciseIcon(exercise.type)"></i>
              </div>
              <div class="type-badge" :class="exercise.type">
                {{ exercise.type === "psikologi" ? "Psikologi" : "Akademik" }}
              </div>
            </div>

            <!-- Exercise Title -->
            <h3 class="exercise-title">
              {{
                exercise.name === "KECERMATAN" ? "SIKAP KERJA" : exercise.name
              }}
            </h3>

            <!-- Action Button -->
            <router-link
              :to="
                `/program/${params.programname}/${
                  params.id
                }/${exercise.name.replace(/\//g, '-').toLowerCase()}/${
                  exercise.id
                }/${exercise.type}`
              "
              class="action-button"
            >
              <span>Lihat Detail</span>
              <i class="uil uil-arrow-right"></i>
            </router-link>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<style scoped>
.exercise-container {
  padding: 1rem 0;
}

.exercise-card {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  height: 100%;
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
}

.exercise-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.25rem;
}

.exercise-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.exercise-icon i {
  font-size: 24px;
}

.exercise-icon.psikologi {
  background: #edf2ff;
  color: #a14dfd;
}

.exercise-icon.akademik {
  background: #ecfdf5;
  color: #059669;
}

.type-badge {
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.35rem 0.75rem;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.type-badge.psikologi {
  background: #edf2ff;
  color: #a14dfd;
}

.type-badge.akademik {
  background: #ecfdf5;
  color: #059669;
}

.exercise-title {
  color: #1f2937;
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0 0 1.5rem 0;
  line-height: 1.4;
  flex-grow: 1;
}

.action-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem;
  background: #a14dfd;
  color: white;
  border-radius: 8px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.2s ease;
}

.action-button:hover {
  background: #a14dfd;
  transform: translateY(-1px);
  color: white;
}

.action-button i {
  font-size: 1.25rem;
  transition: transform 0.2s ease;
}

.action-button:hover i {
  transform: translateX(4px);
}

/* Alert Styling */
.alert {
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .exercise-card {
    padding: 1.25rem;
  }

  .exercise-title {
    font-size: 1rem;
  }
}
</style>

<script>
import appConfig from "@/app.config";

export default {
  components: {},
  page: {
    title: "Student",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "CBT - Siswa",
      items: [
        { text: "Dashboard", href: "/" },
        { text: "Student", active: true },
      ],
      setSubLatihan: [
        { id: 1, name: "KEPRIBADIAN", type: "psikologi" },
        { id: 10, name: "KECERMATAN", type: "psikologi" },
        { id: 2, name: "KECERDASAN", type: "psikologi" },
        { id: 3, name: "KEMAMPUAN VERBAL", type: "psikologi" },
        { id: 4, name: "KEMAMPUAN ABSTRAK", type: "psikologi" },
        { id: 5, name: "KEMAMPUAN PRAKTIS", type: "psikologi" },
        { id: 6, name: "PENGETAHUAN UMUM", type: "akademik" },
        { id: 7, name: "WAWASAN KEBANGSAAN", type: "akademik" },
        { id: 8, name: "BAHASA INGGRIS", type: "akademik" },
        { id: 9, name: "PENALARAN NUMERIK", type: "akademik" },
        { id: 11, name: "UMUM", type: "akademik" },
      ],
      params: this.$route.params,
      isLoading: false,
      errorMessage: false,
    };
  },
  methods: {
    getExerciseIcon(type) {
      return type === "psikologi"
        ? "uil uil-brain exercise-icon psikologi"
        : "uil uil-book-open text-success";
    },
  },
  middleware: "authentication",
};
</script>
